/*
 * @Author: mayanxia 
 * @Date: 2023-03-10 09:10:45 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-03-10 10:31:26
 */
<template>
  <a-modal
    :width="modalWidth"
    :visible="visible"
    :title="$t('区域搜索')"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
    wrapClassName="ant-modal-cust-warp"
    >
    <!--部门树-->
    <template>
      <div>
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
          </div>
        </a-alert>
        <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
        <a-spin tip="Loading..." :spinning="areaLoading">
          <el-tree class="filter-tree" 
            :data="areaTree" 
            :props="defaultProps" 
            :expand-on-click-node="false"
            :filter-node-method="filterNode" 
            :check-on-click-node="true" 
            :check-strictly="checkStrictly"
            :highlight-current="true" 
            node-key="id" 
            :current-node-key="currentNodeKey"
            :default-expanded-keys="iExpandedKeys" 
            @node-click="nodeClick" ref="areaTree">
          </el-tree>
        </a-spin>
      </div>
    </template>
  </a-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { mapActions,mapGetters } from "vuex"
  export default {
    name: "areatSelectWindow",
    components: {
    },
    props: {
      checkStrictly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        modalWidth:400,
        areaLoading: false,
        collapsed: false,// 区域是否收缩
        currSelected: {},
        selectedKeys: [],
        areaTree: [],
        iExpandedKeys: [],
        autoExpandParent: true,
        canceldata:[],
        areaArrList: [],
        searchAreaValue: '',
        rootOpened: true,
        // 20220228改为elementui中tree新增的属性
        defaultProps: {
          children: 'children',
          label: 'areaName'
        },
        currentNodeKey: null,
        confirmLoading: false,
        visible: false,
      }
    },
    computed: {
      // i18n：标题使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
      ...mapGetters({
        areaList: 'areaList',
      })
    },
    watch: {
      searchAreaValue(val) {
        this.$refs.areaTree.filter(val);
      }
    },
    methods: {
      add (checkedAreaKey,checkedAreaName) {
        this.currentNodeKey = checkedAreaKey;
        this.currSelected.key = checkedAreaKey;
        this.currSelected.title = checkedAreaName;
        this.edit({});
      },
      edit (record) {
        this.visible = true;
        this.model = Object.assign({}, record);
        this.loadTree();
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.currSelected = {};
        this.currentNodeKey = null;
      },
      handleSubmit () {
        const that = this;
        // 触发表单验证
        that.confirmLoading = true;
        let formData = {
        currentNodeName: that.currSelected.title,
        currentNodeKey:that.currentNodeKey}
        that.$emit('ok', formData);
        that.confirmLoading = false;
        that.close();
      },
      handleCancel () {
        this.close()
      },
      ...mapActions([ "GetAreaTreeList" ]),
        loadTree() {
            var that = this;
            this.areaLoading = true
            that.areaTree = [];
            console.log(this.areaList)
            if(this.areaList.length === 0) {
              that.GetAreaTreeList().then((res) => {
                if (res.success) {
                  //部门全选后，再添加部门，选中数量增多
                  this.allTreeKeys = [];
                  let arr = [...res.result]
                  this.reWriterWithSlot(arr);
                  this.areaTree = arr
                  if(this.rootOpened){
                    this.setThisExpandedKeys(res.result)
                  }
                }
              }).finally(()=> {
                that.areaLoading = false
              })
            }else{
              let arr = [...this.areaList]
              this.reWriterWithSlot(arr)
              this.areaTree = arr
              if(this.rootOpened){
                this.setThisExpandedKeys(arr)
              }
              this.areaLoading = false
            }
        },
        /**
         * 重新设置标题自定义
         * @param {*} arr 
         */
        reWriterWithSlot(arr){
          for(let item of arr){
            if(item.children && item.children.length>0){
              this.reWriterWithSlot(item.children)
              let temp = Object.assign({},item)
              temp.children = {}
              item.scopedSlots={ title: 'title' }
              this.areaArrList.push(temp)
            }else{
              this.areaArrList.push(item)
              item.scopedSlots={ title: 'title' }
            }
          }
        },
        setThisExpandedKeys(arr){
          if(arr && arr.length>0){
            let keys = []
            for(let item of arr){
              if(item.children && item.children.length>0){
                keys.push(item.id)
              }
            }
            this.iExpandedKeys=[...keys]
          }else{
            this.iExpandedKeys=[]
          }
        },
        refresh() {
          this.loading = true;
          this.loadTree();
        },
        onExpand(expandedKeys) {
          console.log('onExpand', expandedKeys)
          this.iExpandedKeys = expandedKeys;
          this.autoExpandParent = false;
        },
        /*
        onSearch(value) {
            let that = this
            if (value) {
              searchAreaByKeywords({keyWord: value}).then((res) => {
                if (res.success) {
                  that.areaTree = []
                  if(!isNull(res.result)) {
                    for (let i = 0; i < res.result.length; i++) {
                        let temp = res.result[i];
                        that.areaTree.push(temp);
                      }
                  }
                } else {
                  that.$message.warning(res.message)
                }
              })
            } else {
              that.loadTree();
            }
        },
        */
        onSearch(value){
          console.log("执行onSearch")
          const expandedKeys = this.areaArrList.map((item) => {
            if (item.title.indexOf(value) > -1) {
              return this.getParentKey(item.key,this.areaTree)
            }
            return null
          }).filter((item, i, self) => item && self.indexOf(item) === i)
  
          console.log(expandedKeys)
          Object.assign(this, {
            iExpandedKeys: expandedKeys,
            searchAreaValue: value,
            autoExpandParent: true,
          })
        },
        getParentKey(currKey,treeData){
          let parentKey
          for (let i = 0; i < treeData.length; i++) {
            const node = treeData[i]
            if (node.children) {
              if (node.children.some(item => item.key === currKey)) {
                parentKey = node.key
              } else if (this.getParentKey(currKey, node.children)) {
                parentKey = this.getParentKey(currKey, node.children)
              }
            }
          }
          return parentKey
        },
        // 以下是20220228组件改为elementui中tree组件后做的相应的配置
        nodeClick(record,node,data) {
          console.log(record)
          // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
          if(node.checked) {
            this.currentNodeKey = record.id
            this.$refs.areaTree.setCheckedKeys([record.id])
            //this.$refs.areaTree.setCurrentKey(record.id)
            this.currSelected = Object.assign({}, record);
          }else{
            this.currentNodeKey = null
            this.currSelected = {};
          }
          //this.loadData(1);
        },
        getCurrSelectedTitle() {
            return !this.currSelected.title ? '' : this.currSelected.title
        },
        resetAareaData() {
          console.log("areaChoose");
          this.hiding = true;
          this.currSelected = {};
          this.selectedKeys = [];
          if(this.rootOpened){
            this.setThisExpandedKeys(this.areaTree)
          }

          // 20220228修改的
          this.currentNodeKey = null;
          if(this.$refs.areaTree) {
            this.$refs.areaTree.setCheckedKeys([])
          }
          
        },
        unselect() {
          this.resetAareaData();
        },
        filterNode(value, data) {
          console.log(data)
          if (!value) return true;
          return data.areaName.indexOf(value) !== -1;
        },
        getCurrSelectedTitle() {
            return !this.currSelected.title ? '' : this.currSelected.title
        },
    },
  }
</script>